import React from 'react'
import { Field, formValueSelector } from 'redux-form'
import CheckboxField from 'components/form/checkbox'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import MatchHandleField from '../configure-triggers-actions/triggers/twitter/match-handle'

import { ConfigureThreshold } from './threshold'

const selector = formValueSelector('widget')

export const ModerationContainer = ({ children }) => (
  <div className='form-group darkPanel'>
    <div className='col-md-12'>
      <div className='portlet light'>
        <div className='portlet-title'>
          <div className='caption'>
            <span className='caption-subject bold font-green-haze uppercase'>
              <i
                className='glyphicon glyphicon-check hidden-xs'
                style={{
                  alignSelf: 'flex-start',
                  marginTop: 8,
                  marginRight: 8
                }}
              />
              Moderation configuration
            </span>
          </div>
        </div>
        <div className='portlet-body'>{children}</div>
      </div>
    </div>
  </div>
)

ModerationContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export const ToggleModeration = () => (
  <div className='form-group checkGroup'>
    <div className='col-md-12'>
      <Field
        id='brt-experience-moderation'
        name='moderated'
        component={CheckboxField}
        label='Enable moderation for this experience'
        className='icheckbox_square'
      />
    </div>
  </div>
)

export const ModeratorHandlesInput = () => {
  return (
    <div className='form-group row'>
      <label className='col-md-3 control-label'>Moderators</label>
      <div className='col-md-9'>
        <MatchHandleField name='moderators' />
      </div>
    </div>
  )
}

export const ToggleAutoModeration = () => {
  return (
    <div className='form-group checkGroup'>
      <div className='col-md-12'>
        <Field
          id='brt-experience-auto-moderation'
          name='automated'
          component={CheckboxField}
          label='Enable auto moderation for this experience'
          className='icheckbox_square'
        />
      </div>
    </div>
  )
}

export class ConfigureModeration extends React.Component {
  render () {
    return (
      <ModerationContainer>
        <ToggleModeration />
        {this.props.moderated && (
          <div>
            <ToggleAutoModeration />
            <ModeratorHandlesInput />
            <ConfigureThreshold />
          </div>
        )}
      </ModerationContainer>
    )
  }
}

ConfigureModeration.propTypes = {
  moderated: PropTypes.bool
}

const ModerationWithActions = connect(
  // istanbul ignore next
  state => ({
    moderated: selector(state, 'moderated')
  })
)(ConfigureModeration)

export default ModerationWithActions



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-moderation/index.js